import React, { useState } from "react";
import AuthenticityTokenField from "../../../components/forms/AuthenticityTokenField";
import { AddressAutocompleteField } from "../../../components/forms/AddressAutocompleteField";
import { SiteGeofenceMap } from "../../../components/maps/SiteGeofenceMap";
import { DashboardPageLayout } from "../../../components/layout/DashboardPageLayout";
import { Button, ButtonLink } from "../../../components/ui/button";
import { Card, CardContent } from "../../../components/ui/card";
import { FieldLabel, TextInput } from "../../../components/ui/FormControls";
import { DEFAULT_GEOFENCE_RADIUS_M } from "../../../lib/geofenceMap";
import type { MainAppPageProps } from "../types";

type JobNewPageProps = Pick<
  MainAppPageProps,
  "csrfToken" | "googleMapsApiKey" | "routes" | "jobForm"
>;

export const JobNewPage: React.FC<JobNewPageProps> = ({
  csrfToken,
  googleMapsApiKey,
  routes,
  jobForm,
}) => {
  const action = routes.dashboardJobs ?? "/dashboard/jobs";
  const jobsPath = routes.dashboardJobs ?? "/dashboard/jobs";
  const [coords, setCoords] = useState<{ lat: number; lng: number } | null>(
    () => {
      if (
        typeof jobForm?.lat === "number" &&
        typeof jobForm?.lng === "number"
      ) {
        return { lat: jobForm.lat, lng: jobForm.lng };
      }
      return null;
    },
  );

  return (
    <DashboardPageLayout
      trail={[{ label: "Jobs", href: jobsPath }, { label: "Add a job site" }]}
      title="Add a job site"
    >
      <Card className="bg-card">
        <CardContent className="pt-6">
          <form
            action={action}
            method="post"
            className="flex max-w-xl flex-col gap-5"
          >
            <AuthenticityTokenField csrfToken={csrfToken} />
            <div>
              <FieldLabel htmlFor="job_name">Job name</FieldLabel>
              <TextInput
                id="job_name"
                name="job[name]"
                defaultValue={jobForm?.name ?? ""}
                placeholder="Kitchen remodel"
                required
              />
            </div>
            <AddressAutocompleteField
              id="job_address"
              label="Address"
              addressFieldName="job[address]"
              placeIdFieldName="job[place_id]"
              latFieldName="job[lat]"
              lngFieldName="job[lng]"
              defaultValue={jobForm?.address ?? ""}
              defaultLat={jobForm?.lat}
              defaultLng={jobForm?.lng}
              googleMapsApiKey={googleMapsApiKey}
              placeholder="123 Main St"
              onResolved={(location) => {
                setCoords(
                  location ? { lat: location.lat, lng: location.lng } : null,
                );
              }}
            />
            <SiteGeofenceMap
              googleMapsApiKey={googleMapsApiKey}
              lat={coords?.lat}
              lng={coords?.lng}
              defaultRadiusM={
                jobForm?.geofenceRadiusM ?? DEFAULT_GEOFENCE_RADIUS_M
              }
              includeCoordinateFields={false}
            />
            <Button type="submit" variant="premium">
              Save job site
            </Button>
          </form>
        </CardContent>
      </Card>
    </DashboardPageLayout>
  );
};
